module.exports = __webpack_public_path__ + "static/media/file.6be38285.svg";